<template>
    <div class="nearNewsList" @click="getNewsDetailInfo (nearNews.id)">
        <div class="nearNewsList_left">
            <h2>{{this.nearNews.title}}</h2>
            <p><span>{{timeFormat(this.nearNews.add_time)}}</span> <span>浏览次数：{{this.nearNews.click}}</span></p>
        </div>
        <div class="nearNewsList_right">
            <img :src="weburl+this.nearNews.thumb" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        name: "nearNewsList",
        props: ['nearNews'],
        created: function () {
          /*  console.log(this.nearNews)*/
        },
        inject:['reload'],
        methods: {
            //时间戳转化成时间格式
            Timer (m) {
                return m < 10 ? '0' + m : m;
            },
            timeFormat(timeline) {
                var t_html = '';
                // for (var i = 0; i < arr.length; i++) {
                /*          var word = i === 0 ? "至" : "开始";*/
                //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
                var time = new Date(timeline);
                var year = time.getFullYear();
                var month = time.getMonth() + 1;
                var date = time.getDate();
                t_html += year + '-' +this.Timer(month) + '-' + this.Timer(date);
                return t_html;
            },

            getNewsDetailInfo(id) {
                console.log(id);
                this.$router.push({path: `/newsDetail/${id}`});
                this.reload();
            }

        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }

        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common";

    .nearNewsList {
        width: 100%;
        height: 125px;
        .box-sizing;
        padding: 15px 0;
        .border-bottom;
        .nearNewsList_left {
            float: left;
            width: 64%;
            height: @width;
            margin-right: 6%;
            position: relative;
            h2 {
                line-height: 24px;
                overflow: hidden;
                -webkit-line-clamp: 3;
                display: -webkit-box;
                -webkit-box-orient: vertical;
            }
            p {
                width: @width;
                position: absolute;
                bottom: 0;
                left: 0;
                font-size: .4rem;
                color: @word;
                span:last-child {
                    float: right;
                }

            }
        }
        .nearNewsList_right {
            float: right;
            width: 30%;
            height: @width;
            .border-radius(10px);
            img {
                .img;
                .border-radius(10px);
            }

        }
    }

</style>
